"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEW = exports.ISSUE = exports.COMPONENT_VIEW = void 0;
var VIEW = {
  PERFORMANCE: 'overview',
  OPERATIONS: 'operations',
  BACKLOG: 'backlog',
  MISSEDSLA: 'missed-sla'
};
exports.VIEW = VIEW;
var ISSUE = {
  FORBIDDEN: 'forbidden'
};
exports.ISSUE = ISSUE;
var COMPONENT_VIEW = {
  NETWORK: 'network',
  FULFILLER: 'fulfiller',
  MERCHANT_FULFILLER: 'merchant-fulfiller'
};
exports.COMPONENT_VIEW = COMPONENT_VIEW;